import type { AxiosResponse } from "axios";
import { createMutation } from "react-query-kit";

import type { INoShowAppointmentParams } from "@api/appointment/types";
import { generatePath } from "@routes/generatePath.ts";
import { useAppointmentTable } from "@api/appointment/getAppointmentTable";
import { useShowAppointment } from "@api/appointment/showAppointment";
import { useAppointmentDetail } from "@api/appointment/getAppointmentDetail";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, queryClient } from "@/api";

type IResponse = AxiosResponse<IApiResponse<unknown>>;
type IVariables = INoShowAppointmentParams;

export const noShowAppointment: IAxiosFn<IVariables, IResponse> = (
  data,
  signal,
) => {
  return axiosClient.put(
    generatePath("/appointments/:appointment_id/report", {
      appointment_id: data?.appointmentId,
    }),
    data,
    { signal },
  );
};

export const useNoShowAppointment = createMutation<IResponse, IVariables>({
  mutationFn: (data) => noShowAppointment(data),
  onSuccess: (_, { appointmentId }) => {
    queryClient.invalidateQueries(useAppointmentTable.getKey());
    queryClient.invalidateQueries(useShowAppointment.getKey({ appointmentId }));
    queryClient.invalidateQueries(
      useAppointmentDetail.getKey({ id: appointmentId?.toString() }),
    );
  },
});
